import { AuthState } from '@/features/auth/auth.def.ts';
import { createSlice } from '@reduxjs/toolkit';
import { authApi } from '@/features/auth/auth.api.ts';
import { decodeToken } from '@/features/auth/auth.utils.ts';
import { uniqBy } from 'lodash-es';

const initialState: AuthState = {
  user: undefined,
  impersonatedUsername: undefined,
  permissions: undefined,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: () => initialState,
    setAuth: (state, action) => {
      state.user = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(authApi.endpoints.login.matchFulfilled, (state, action) => {
        const user = decodeToken(action.payload.data.accessToken);
        return { ...state, user };
      })
      .addMatcher(authApi.endpoints.login.matchRejected, (state) => {
        return { ...state, user: undefined };
      })
      .addMatcher(authApi.endpoints.impersonateUser.matchFulfilled, (state, action) => {
        const user = decodeToken(action.payload.data.accessToken);
        return { ...state, user, impersonatedUsername: user.name };
      })
      .addMatcher(authApi.endpoints?.getPermissions.matchFulfilled, (state, action) => {
        const list = uniqBy(action.payload.data, (x) => `${x.moduleName}:${x.functionName}`);
        return { ...state, permissions: list };
      })
      .addMatcher(authApi.endpoints?.getPermissions.matchRejected, (state) => {
        return { ...state, permissions: undefined };
      })
      .addMatcher(authApi.endpoints?.getRoles.matchFulfilled, (state, action) => {
        if (state.user) {
          const user = { ...state.user, roles: action.payload.data };
          return { ...state, user };
        }
      });
  },
});

export const { logout } = authSlice.actions;
